export const demandForecastData = [
  { date: '2023-01', demand: 4000, forecast: 4200 },
  { date: '2023-02', demand: 3000, forecast: 3200 },
  { date: '2023-03', demand: 5000, forecast: 4800 },
  { date: '2023-04', demand: 4500, forecast: 4600 },
  { date: '2023-05', demand: 6000, forecast: 5800 },
  { date: '2023-06', demand: 5500, forecast: 5600 },
  { date: '2023-07', demand: 6500, forecast: 6400 },
  { date: '2023-08', demand: 7000, forecast: 6800 },
  { date: '2023-09', demand: 6800, forecast: 7000 },
  { date: '2023-10', demand: 7200, forecast: 7300 },
  { date: '2023-11', demand: 7500, forecast: 7600 },
  { date: '2023-12', demand: 8000, forecast: 8100 },
]; 